  export function changeTitle (title) {
    let dom = document.querySelector('title')
    if (dom) {
      dom.innerText = title
    }
  }
  export function changeKeywords (title) {
    let dom = document.querySelector('meta[name="keywords"]')
    if (dom) {
      dom.setAttribute("content",title)
    }
  }
  export function changeDescription (title) {
    let dom = document.querySelector('meta[name="description"]')
    if (dom) {
      dom.setAttribute("content",title)
    }
  }